import { ReactNode } from "react";

import { ReactComponent as TrashIcon } from "assets/images/iconsV2/trash-01.svg";
import { ReactComponent as PlusIcon } from "assets/images/iconsV2/plus-02.svg";
import Button from "components/v2/Button/Button";

interface StopPlanningToggleGroupProps {
  isVisible: boolean;
  addLabel: string;
  removeLabel: string;
  onToggle: () => void;
  children?: ReactNode;
}

export default function StopPlanningToggleGroup({
  isVisible,
  addLabel,
  removeLabel,
  onToggle,
  children,
}: StopPlanningToggleGroupProps) {
  return (
    <div className="rfv2-schedule-planning__toggle-group">
      <Button
        type="button"
        variant="link-gray"
        size="sm"
        className="rfv2-schedule-link-action"
        iconLeft={isVisible ? <TrashIcon /> : <PlusIcon />}
        label={isVisible ? removeLabel : addLabel}
        onClick={onToggle}
      />
      {isVisible && children}
    </div>
  );
}
